var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCasualLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    height: "300%",
    width: "300%",
    y: "-100%",
    x: "-100%",
    id: "$id-filter"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "cutoff"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    intercept: -40,
    slope: 60,
    type: "linear"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#$id-filter)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    dur: "3.3333333333333335s",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 0,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.7666666666666666 0 0.6666666666666666 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 1,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.7333333333333333 0 0.6333333333333333 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 2,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.7 0 0.6 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 3,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.6666666666666666 0 0.5666666666666667 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 4,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.6333333333333333 0 0.5333333333333333 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 5,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.6 0 0.5 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 6,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.5666666666666667 0 0.4666666666666667 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 7,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.5333333333333333 0 0.43333333333333335 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 8,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.5 0 0.4 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 9,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.4666666666666667 0 0.36666666666666664 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 10,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.43333333333333335 0 0.3333333333333333 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 11,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.4 0 0.3 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 12,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.3666666666666667 0 0.26666666666666666 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 13,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.33333333333333337 0 0.23333333333333334 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 14,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.30000000000000004 0 0.2 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 15,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.26666666666666666 0 0.16666666666666666 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 16,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.23333333333333334 0 0.13333333333333333 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 17,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.2 0 0.1 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 18,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.16666666666666669 0 0.06666666666666667 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(0.5)",
    fill: "#016dff",
    r: 19,
    cy: 0,
    cx: 0
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    keySplines: "0.13333333333333333 0 0.03333333333333333 1",
    dur: 1.1111111111111112,
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    type: "rotate",
    calcMode: "spline",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCasualLoader);
export default __webpack_public_path__ + "static/media/blue-casual-loader.8d9360bec28dec25edd9020b71ed3492.svg";
export { ForwardRef as ReactComponent };